<template>
  <div>
    <div style="float: right;font-size: 12px;color: #606266;margin:10px 5px 0 0">
      <span><i class="el-icon-star-on" style="color: #d81e19; margin-left: 8px;"/>发货收入</span>
      <span><i class="el-icon-star-on" style="color: #32b356; margin-left: 8px;"/>交期在当期的销售订单</span>
      <span><i class="el-icon-star-on" style="color: #E6A23C; margin-left: 8px;"/>当前新收到销售订单</span>
    </div>
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="按区域" name="first">
        <customer-sales-report-bu/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import CustomerSalesReportBu from "./CustomerSalesReportBu.vue";

  export default {
    name: "CustomerSalesReport",
    components: {
      CustomerSalesReportBu,
    },
    data() {
      return {
        activeName: "first",
      };
    },
    methods: {},
  };
</script>

<style lang="scss" scoped>
</style>
